import { useState } from "react";
import bot from "../../assets/images/happy.png";
import you from '../../assets/images/boy.png';
import Lastmenu from "./LastMenu";

const GetInTouch = () => {
    const [time] = useState(new Date().toLocaleTimeString());
    const [form, setForm] = useState({
        name: "",
        mobile: "",
        email: "",
        comment: "",
    });
    const [errors, setErrors] = useState({});

    const [showFrame, setShowFrame] = useState(false);

    const validateField = (name, value) => {
        let error = "";

        switch (name) {
            case "name":
                if (!value.trim()) {
                    error = "Name is required";
                } else if (!/^[A-Za-z\s]+$/.test(value)) {
                    error = "Only letters and spaces allowed";
                }
                break;

            case "mobile":
                if (!value.trim()) {
                    error = "Mobile is required";
                } else if (!/^\d+$/.test(value)) {
                    error = "Only digits allowed";
                } else if (value.length !== 10) {
                    error = "Must be exactly 10 digits";
                }
                break;

            case "email":
                if (!value.trim()) {
                    error = "Email is required";
                }
                break;

            case "comment":
                if (!value.trim()) {
                    error = "Comment is required";
                }
                break;

            default:
                break;
        }

        setErrors((prev) => ({ ...prev, [name]: error }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Prevent invalid characters from even being typed
        if (name === "name" && /[^A-Za-z\s]/.test(value)) return;
        if (name === "mobile" && /[^0-9]/.test(value)) return;
        if (name === "mobile" && value.length > 10) return;

        setForm({ ...form, [name]: value });
        validateField(name, value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        Object.entries(form).forEach(([key, value]) => validateField(key, value));
        const hasErrors = Object.values(errors).some((err) => err);
        const hasEmpty = Object.values(form).some((v) => !v.trim());

        if (!hasErrors && !hasEmpty) {
            setShowFrame(true);
            setForm({ name: "", mobile: "", email: "", comment: "" });
            setErrors({});
        }
    };

    const inputClass = (field) =>
        `input-text2 ${errors[field] ? "input-error" : ""}`;

    return (
        <>
            <div className="chatbot">
                <img src={bot} alt="bot" className="bot" />
                <div className="chatbot-time">{time}</div>
            </div>

            <div className="frame1 animated-frame" style={{ textAlign: "center" }}>
                <h2>Please Enter Your Details</h2>
                <form onSubmit={handleSubmit} noValidate>
                    <input
                        type="text"
                        name="name"
                        className={inputClass("name")}
                        placeholder="Enter Name"
                        value={form.name}
                        onChange={handleChange}
                    />
                    {errors.name && <div className="error-text">{errors.name}</div>}

                    <input
                        type="text"
                        name="mobile"
                        className={inputClass("mobile")}
                        placeholder="Enter Mobile"
                        value={form.mobile}
                        onChange={handleChange}
                    />
                    {errors.mobile && <div className="error-text">{errors.mobile}</div>}

                    <input
                        type="email"
                        name="email"
                        className={inputClass("email")}
                        placeholder="Enter Email"
                        value={form.email}
                        onChange={handleChange}
                    />
                    {errors.email && <div className="error-text">{errors.email}</div>}

                    <input
                        type="text"
                        name="comment"
                        className={inputClass("comment")}
                        placeholder="Enter Comment"
                        value={form.comment}
                        onChange={handleChange}
                    />
                    {errors.comment && <div className="error-text">{errors.comment}</div>}

                    <button type="submit" className="detatils-button2">
                        Submit
                    </button>
                </form>
            </div>
            {showFrame && (
                <>

                <div className="you-time">
                    <img src={you} alt="boy" className="boy" />
                    You {time}
                    </div>
                    <div className="you-message">
                    <div className="frame2">Submit</div>
                    </div>

                <div className="chatbot">
                    <img src={bot} alt="bot" className="bot" />
                    <div className="chatbot-time">{time}</div>
                </div>
                
                    <div className="frame1 animated-frame">
                        Thank you for your response,<br></br>Our team will get back to you soon!
                    </div>
                    <Lastmenu />
                </>
            )}
        </>
    );
};

export default GetInTouch;
